import componentTranslations from './components'

export default {
  ...componentTranslations
}
